import { SalesOrder } from '@spa/services/api/purchase'

export const initialPurchaseState: PurchaseState = {
  latestItem: null,
  error: {},
}

export interface PurchaseState {
  latestItem: SalesOrder | null,
  error: {
    load?: Error | null,
  },
}
